import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { UiProvider } from '@allrouted/ui/Toaster';
import { AuthGate } from './components/AuthGate';
import '@allrouted/ui/styles/app.css';
import '@allrouted/ui/styles/auth.css';
import '@allrouted/ui/styles/brand.css';

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root');

createRoot(root).render(
  <StrictMode>
    <UiProvider>
      <AuthGate>
        <App />
      </AuthGate>
    </UiProvider>
  </StrictMode>,
);
